import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAppointmentContext } from '../../shared/contexts';
import { LayoutShell, LayoutRegister } from '../../shared/layouts';
import { CreateAppointmentForm } from '../../shared/components/SconApp/createAppointment/CreateAppointmentForm';

export const Appointment: React.FC = () => {
  const [formApi, setFormApi] = useState<{ isLoading: boolean; canSubmit: boolean; submit: () => void }>();

  const {
    appointment,
    setAppointment,
    viaScheduler,
    walkIn,
    setWalkIn,
    blockBusiness,
    setBlockBusiness,
    blockEmployee,
    setBlockEmployee
  } = useAppointmentContext();

  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { businessId, businessEmployeeId } = useParams<{ businessId: string; businessEmployeeId: string }>();

  // Handle URL params → context (public booking flow)
  useEffect(() => {
    if (!appointment && businessId && !businessEmployeeId) {
      setAppointment({ businessId: parseInt(businessId) });
      setBlockBusiness(true);
    }

    if (!appointment && businessId && businessEmployeeId) {
      setAppointment({
        businessId: parseInt(businessId),
        businessEmployeeId: parseInt(businessEmployeeId),
      });
      setBlockBusiness(true);
      setBlockEmployee(true);
    }
  }, [businessId, businessEmployeeId]);

  // Cleanup context on unmount
  useEffect(() => {
    return () => {
      setAppointment(undefined);
      setWalkIn(false);
      setBlockBusiness(false);
      setBlockEmployee(false);
    };
  }, []);

  return (
    <LayoutShell>
      <LayoutRegister
        header={walkIn ? 'Novo encaixe' : 'Novo agendamento'}
        hideSaveButton
        onClickSave={() => formApi?.submit()}
        isLoading={formApi?.isLoading}
        disabled={!formApi?.canSubmit}
        saveButtonDataTestId='btn-submit-appointment'
      >
        <CreateAppointmentForm
          businessId={appointment?.businessId || (businessId ? parseInt(businessId) : undefined)}
          businessEmployeeId={appointment?.businessEmployeeId || (businessEmployeeId ? parseInt(businessEmployeeId) : undefined)}
          serviceId={appointment?.serviceId}
          walkIn={walkIn}
          viaScheduler={viaScheduler}
          blockBusiness={blockBusiness}
          blockEmployee={blockEmployee}
          onSuccess={() => {
            setWalkIn(false);
            queryClient.invalidateQueries({ queryKey: ['user'] });
            navigate('/home');
          }}
          onFormReady={setFormApi}
        />
      </LayoutRegister>
    </LayoutShell>
  );
};
